import { axiosLevelTech } from '../axiosConfig';
import { showToast } from '@/services/notifications/toastService';

// TypeScript interface for Player operations
export interface PlayerUpdateParams {
  boxid: number;
  playerId: number;
  playerId2?: number;
  position?: number;
  hide?: boolean;
  withdrawn?: boolean;
}

export interface PlayerDetailsParams {
  playerId?: number | string;
  personId?: number | string;
}

export interface PlayerSimpleParams {
  boxid: number;
  playerId: number | string;
  playerId2?: number | string;
}

export interface AddDoublesPairParams {
  boxid: number;
  playerId: number;
  playerId2: number;
  position?: number;
  hide?: boolean;
  withdrawn?: boolean;
}

export interface AddNewPlayerParams {
  clubid: string;
  name: string;
}

// Function to update player details
export const updatePlayer = async (params: PlayerUpdateParams) => {
  return axiosLevelTech
    .post('/api/boxes/UpdatePlayer', params)
    .then((response) => {
      if (response.data.status === 'Success') {
        showToast('success', response.data.message || 'Player updated successfully!');
      } else {
        showToast('error', response.data.message || 'Failed to update player.');
        throw new Error(response.data.message ?? 'An unknown error occurred.');
      }
      return response.data;
    })
    .catch((error) => {
      showToast('error', error.response?.data?.message || `${error.message}`);
      throw new Error(error.message ?? 'An unknown error occurred.');
    });
};

// Function to add doubles pair
export const addDoublesPair = async (params: AddDoublesPairParams) => {
  return axiosLevelTech
    .post('/api/boxes/AddDoublesPair', params)
    .then((response) => {
      if (response.data.status === 'Success') {
        showToast('success', response.data.message || 'Doubles pair added successfully!');
      } else {
        showToast('error', response.data.message || 'Failed to add doubles pair.');
        throw new Error(response.data.message ?? 'An unknown error occurred.');
      }
      return response.data;
    })
    .catch((error) => {
      showToast('error', error.response?.data?.message || `${error.message}`);
      throw new Error(error.message ?? 'An unknown error occurred.');
    });
};

// Function to remove a player from a box
export const removePlayer = async (params: PlayerSimpleParams) => {
  return axiosLevelTech
    .post('/api/boxes/RemovePlayer', params)
    .then((response) => {
      if (response.data.status === 'Success') {
        showToast('success', response.data.message || 'Player removed successfully!');
      } else {
        showToast('error', response.data.message || 'Failed to remove player.');
        throw new Error(response.data.message ?? 'An unknown error occurred.');
      }
      return response.data;
    })
    .catch((error) => {
      showToast('error', error.response?.data?.message || `${error.message}`);
      throw new Error(error.message ?? 'An unknown error occurred.');
    });
};

// Function to hide a player
export const hidePlayer = async (params: PlayerSimpleParams) => {
  return axiosLevelTech
    .post('/api/boxes/HidePlayer', params)
    .then((response) => {
      if (response.data.status === 'Success') {
        showToast('success', response.data.message || 'Player hidden successfully!');
      } else {
        showToast('error', response.data.message || 'Failed to hide player.');
        throw new Error(response.data.message ?? 'An unknown error occurred.');
      }
      return response.data;
    })
    .catch((error) => {
      showToast('error', error.response?.data?.message || `${error.message}`);
      throw new Error(error.message ?? 'An unknown error occurred.');
    });
};

// Function to unhide a player
export const unhidePlayer = async (params: PlayerSimpleParams) => {
  return axiosLevelTech
    .post('/api/boxes/UnhidePlayer', params)
    .then((response) => {
      if (response.data.status === 'Success') {
        showToast('success', response.data.message || 'Player unhidden successfully!');
      } else {
        showToast('error', response.data.message || 'Failed to unhide player.');
        throw new Error(response.data.message ?? 'An unknown error occurred.');
      }
      return response.data;
    })
    .catch((error) => {
      showToast('error', error.response?.data?.message || `${error.message}`);
      throw new Error(error.message ?? 'An unknown error occurred.');
    });
};

// Function to get player details
export const getPlayerDetails = async (params: PlayerDetailsParams) => {
  return axiosLevelTech
    .post('/api/player/GetPlayerDetails', params)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      showToast('error', error.response?.data?.message || `${error.message}`);
      throw new Error(error.message ?? 'An unknown error occurred.');
    });
};

// Function to add a new player to the site
export const addNewPlayerToSite = async (params: AddNewPlayerParams) => {
  return axiosLevelTech
    .post('/api/player/AddNewPlayer', params)
    .then((response) => {
      if (response.data.status === 'Success') {
        showToast('success', response.data.message || 'Player added successfully!');
      } else {
        showToast('error', response.data.message || 'Failed to add player.');
        throw new Error(response.data.message ?? 'An unknown error occurred.');
      }
      return response.data;
    })
    .catch((error) => {
      showToast('error', error.response?.data?.message || `${error.message}`);
      throw new Error(error.message ?? 'An unknown error occurred.');
    });
};
